import Navbar from "../../../components/Navbar/Navbar";
import ClientFormsWrapper from "../components/ClientFormsWrapper/ClientFormsWrapper";

export default function FormsPage() {
    return (
        <>
            <Navbar title="My Forms" />
            <ClientFormsWrapper />
        </>
    );
}
